import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";
import { createArray } from "utils/surveyHelper";

const FeedbackSideSurveyDetail = () => {
  return (
    <div className="participants_summery">
      <div className="_card">
        <SkeletonLoader type={"text"} height={25} width={165} bottomGap={10} />
        <ul>
          {createArray(4).map((index) => (
            <li key={`first-${index}`}>
              <SkeletonLoader type={"text"} height={22} width={240} />
            </li>
          ))}
        </ul>
        <SkeletonLoader type={"text"} height={26} width={170} bottomGap={10} />
        <ul>
          {createArray(4).map((index) => (
            <React.Fragment key={`second-${index}`}>
              <li>
                <SkeletonLoader
                  type={"text"}
                  height={20}
                  width={100}
                  bottomGap={8}
                />
                <p>
                  <SkeletonLoader type={"text"} height={22} width={240} />
                </p>
              </li>
              <li>
                <SkeletonLoader
                  type={"text"}
                  height={20}
                  width={100}
                  bottomGap={10}
                />
                <p>
                  <b>
                    <SkeletonLoader type={"text"} height={20} width={60} />
                  </b>
                  <b>
                    <SkeletonLoader type={"text"} height={20} width={60} />
                  </b>
                </p>
              </li>
            </React.Fragment>
          ))}
        </ul>
        <div className="button_wrap">
          <SkeletonLoader type={"text"} height={45} width={250} bottomGap={8} />
          <SkeletonLoader type={"text"} height={45} width={250} bottomGap={8} />
        </div>
      </div>
    </div>
  );
};

export default FeedbackSideSurveyDetail;
